import type { Chip, GroupIn } from '@/entities/tour-activities';

export function normalizeGroups(groups: GroupIn[]): GroupIn[] {
  return groups.map((g) => ({
    ...g,
    tags: g.tags.map((tag) => ({ ...tag, name: tag.label })),
  }));
}

export function matchGroups(query: string, groups: GroupIn[]): Chip[] {
  const q = query.trim().toLowerCase();
  if (!q) {
    return [];
  }

  const matched: Chip[] = [];
  for (const g of groups) {
    for (const tag of g.tags) {
      const base = String(tag.label ?? '');
      if (base.toLowerCase().includes(q)) {
        matched.push({ ...tag, label: base });
      }
    }
  }

  return matched;
}

/** Строит видимые группы для UI (или объединённую группу при поиске) */
export function buildVisibleGroups(query: string, groups: GroupIn[]): GroupIn[] {
  const q = String(query || '');
  if (!q.length) {
    return normalizeGroups(groups);
  }

  return [{ title: null, tags: matchGroups(q, groups) }];
}
